module.exports = __webpack_public_path__ + "img/logo-arene.44cd0b14.png";